export default __webpack_public_path__ + "static/media/1474.9e62bf40.png";